<template>
  <div>
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Booker Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Ancillary Rate
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="manageGlobalRates()"
                >
                  <span><i class="ic-baggage"></i></span>Global Ancillary
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Ancillary Rate
                    <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>
                    Manage ancillary items as part of your products and
                    services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Class</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="detail-row"
                  v-for="item in table.items"
                  :key="item.id"
                >
                  <td>{{ item.masterClassName }}</td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="
                          isAllowToCreate || isAllowToUpdate || isAllowToDelete
                        "
                        class="btn btn-default"
                        type="button"
                        @click="manageRate(item)"
                      >
                        <span>Manage</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              />
            </nav>
          </div>
        </div>
      </div>
    </section>

    <div
      class="modal fade"
      role="dialog"
      ref="vuemodal"
      v-if="selectedMasterClass"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header modal-sell" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  <span v-if="isGlobal">Global Ancillary Rate</span>
                  <span v-else>
                    Ancillary Rate ({{ selectedMasterClass.masterClassName }})
                  </span>
                </h4>
                <h6 v-if="timestampItem">Last Updated: {{ timestampItem }}</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onCloseModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="modal-content-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="col-sm-3 divider-right pr-25">
                      <div class="summary-error" v-if="$v.model.$error">
                        This form has errors
                      </div>
                      <div class="form-group">
                        <label class="required">Service Type</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.serviceType.$error,
                          }"
                          placeholder="Select type"
                          label="text"
                          v-model="model.serviceType"
                          :options="serviceTypes"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.value"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.serviceType.required"
                        >
                          Service type is required
                        </small>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <label class="required">Item Name</label>
                          <div class="row">
                            <div class="col-sm-9">
                              <div class="form-group">
                                <v-select
                                  class="v-search-select"
                                  :class="{
                                    'field-error':
                                      isSubmitted && $v.model.name.$error,
                                  }"
                                  placeholder="Select name"
                                  label="name"
                                  v-model="model.name"
                                  :options="predefinedNames"
                                  :clearable="true"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.name"
                                />
                                <small
                                  class="form-text sts-danger"
                                  v-if="isSubmitted && !$v.model.name.required"
                                >
                                  Name is required
                                </small>
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <button
                                  type="submit"
                                  class="btn btn-default"
                                  @click.prevent="addPredefinedName()"
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="required">Currency</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.currency.$error,
                          }"
                          placeholder="Select currency"
                          label="text"
                          v-model="model.currency"
                          :options="currencies"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.value"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.currency.required"
                        >
                          Currency is required
                        </small>
                      </div>
                      <div class="form-group">
                        <label class="required">Rate</label>
                        <currency-input
                          class="form-control"
                          :class="{
                            'field-error': isSubmitted && $v.model.rate.$error,
                          }"
                          autocomplete="off"
                          placeholder="Enter rate"
                          v-model="model.rate"
                          :allow-negative="false"
                          :currency="null"
                          :locale="moneyFormat.cultureCode"
                          :precision="moneyFormat.numberOfDecimal"
                        />
                        <div v-if="isSubmitted && $v.model.rate.$error">
                          <small
                            class="form-text sts-danger"
                            v-if="!$v.model.rate.required"
                          >
                            Rate is required
                          </small>
                          <small
                            class="form-text sts-danger"
                            v-if="!$v.model.rate.minValue"
                          >
                            Min rate is {{ $v.model.rate.$params.minValue.min }}
                          </small>
                        </div>
                      </div>
                      <div class="form-group" v-if="model.serviceType == 2">
                        <label class="required">Calculation Type</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.calculationType.$error,
                          }"
                          placeholder="Select type"
                          label="text"
                          v-model="model.calculationType"
                          :options="calculationTypes"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.value"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && $v.model.calculationType.$error"
                        >
                          Calculation type is required
                        </small>
                      </div>
                      <div class="form-group">
                        <label class="required">Zones</label>
                        <multiselect
                          v-model="model.zones"
                          :class="{
                            'field-error':
                              isSubmitted && !$v.model.zones.required,
                          }"
                          :options="zones"
                          :multiple="true"
                          :close-on-select="false"
                          placeholder="Select zones"
                          label="label"
                          track-by="id"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.zones.required"
                        >
                          Zone(s) is required
                        </small>
                      </div>
                      <div
                        class="modal-footer"
                        v-if="isAllowToCreate || isAllowToUpdate"
                      >
                        <button
                          type="button"
                          class="btn btn-default"
                          @click.prevent="onResetForm()"
                        >
                          Reset
                        </button>
                        <button
                          v-if="!isUpdate && isAllowToCreate"
                          type="button"
                          class="btn btn-primary"
                          @click.prevent="onSubmitForm()"
                        >
                          Create
                        </button>
                        <button
                          v-if="isUpdate && isAllowToUpdate"
                          type="button"
                          class="btn btn-primary"
                          @click.prevent="onSubmitForm()"
                        >
                          Update
                        </button>
                      </div>
                    </div>

                    <div class="col-sm-9 divider-left pl-20">
                      <div class="table-modal-detail">
                        <div class="table-responsive table-accordion">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th class="number">No</th>
                                <th>Item</th>
                                <th>Zones</th>
                                <th class="text-right">Rate</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in rates" :key="item.id">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td>
                                  <p class="mb-0">
                                    <small class="text-muted">{{
                                      printServiceType(item)
                                    }}</small>
                                  </p>
                                  {{ item.name }}
                                </td>
                                <td>
                                  <template
                                    v-if="item.zones && item.zones.length > 0"
                                  >
                                    <p
                                      class="mb-0"
                                      v-for="(zoneItem, idxZone) in item.zones"
                                      :key="idxZone"
                                    >
                                      {{
                                        `${zoneItem.group} - ${zoneItem.name}`
                                      }}
                                    </p>
                                  </template>
                                  <template v-else> - </template>
                                </td>
                                <td class="text-right">
                                  {{ item.currency }}
                                  {{ printMoney(item.rate) }}
                                  <p
                                    v-if="item.calculationType == 2"
                                    class="small mb-0"
                                  >
                                    / days
                                  </p>
                                </td>
                                <td class="text-center">
                                  <label class="cursor-pointer">
                                    <input
                                      type="checkbox"
                                      class="control-checkbox"
                                      v-model="item.isActive"
                                      :disabled="!isAllowToUpdate"
                                      @change="onChangeStatus(item)"
                                    />
                                    <span
                                      class="pl-5 font-weight-normal v-align-middle"
                                    >
                                      {{
                                        item.isActive ? "Active" : "Inactive"
                                      }}
                                    </span>
                                  </label>
                                </td>
                                <td class="text-center">
                                  <div class="button-action-wrapper">
                                    <button
                                      v-if="isAllowToUpdate"
                                      class="btn btn-default"
                                      type="button"
                                      @click="onEdit(item)"
                                    >
                                      <span>Edit</span>
                                    </button>
                                    <button
                                      v-if="isAllowToDelete"
                                      class="btn btn-default"
                                      type="button"
                                      @click="onDelete(item)"
                                    >
                                      <i class="ic-close"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />
    <loader :content="msg" :visible="isLoading" />
  </div>
</template>

<script>
import { required, minValue, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import masterAncillaryService from "@/services/master/masterAncillaryService.js";
import sellingTariffAncillaryRateService from "@/services/master/sellingTariff/sellingTariffAncillaryRateService.js";
import exchangeRateService from "@/services/master/exchangeRate/exchangeRateService.js";
import zoneService from "@/services/master/zone/zoneService.js";
import { tryParseFloat } from "@/helpers/numberHelper";
import {
  DefaultTableObject,
  ServiceTypes,
  AncillaryCalculationType,
  AncillaryCalculationTypeArray,
} from "@/models/constants";

const defaultModel = {
  id: null,
  isGlobal: null,
  masterClassId: null,
  serviceType: null,
  name: null,
  currency: null,
  rate: null,
  calculationType: null,
  isActive: true,
  zones: [],
};

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    validationRuleCalculationType: function () {
      return this.model && this.model.serviceType && this.model.serviceType == 2
        ? { required }
        : {};
    },
  },
  data() {
    return {
      isLoading: false,
      msg: "Please wait",
      selectedMasterClass: null,
      formatter: null,
      moneyFormat: null,
      isGlobal: false,
      isUpdate: false,
      isSubmitted: false,
      isItemHasBeenModified: false,
      timestampItem: null,
      itemIdToBeDeleted: null,
      table: DefaultTableObject,
      model: defaultModel,
      serviceTypes: ServiceTypes,
      calculationTypes: AncillaryCalculationTypeArray,
      allPermissions: [],
      currencies: [],
      predefinedNames: [],
      zones: [],
      rates: [],
    };
  },
  validations() {
    return {
      model: {
        serviceType: { required },
        name: { required },
        currency: { required, maxLength: maxLength(3) },
        rate: { required, minValue: minValue(0) },
        calculationType: this.validationRuleCalculationType,
        zones: { required },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();

    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];

    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getAllZones();
      await this.getPredefinedNames();
      await this.getCurrencySelection();

      if (this.moneyFormat) {
        this.formatter = new Intl.NumberFormat(this.moneyFormat.cultureCode, {
          style: "currency",
          currency: this.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: this.moneyFormat.numberOfDecimal,
        });
      }
    }
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-ancillary-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async getAll() {
      try {
        this.isLoading = true;

        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;

        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }

        const response = await sellingTariffAncillaryRateService.getAll(filter);

        this.moneyFormat = response.data.moneyFormat;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
        this.table.items = response.data.items;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAllZones() {
      this.zones = await zoneService.getAllActive();

      for (let i = 0; i < this.zones.length; i++) {
        const item = this.zones[i];
        item.label = `${item.group} ${item.name}`;
      }
    },
    async getPredefinedNames() {
      const response = await masterAncillaryService.getAll();

      if (response) {
        this.predefinedNames = response;
      }
    },
    async getCurrencySelection() {
      const response = await exchangeRateService.getCurrencySelection();

      if (response && Object.keys(response).length > 0) {
        this.currencies = Object.entries(response).map(([key, value]) => ({
          value: key,
          text: value,
        }));
      }
    },
    async getGlobalRates() {
      this.rates = await sellingTariffAncillaryRateService.getGlobalRates();
    },
    async getRates(masterClassId) {
      this.rates = await sellingTariffAncillaryRateService.getRates(
        masterClassId
      );
    },
    async manageGlobalRates() {
      try {
        this.isLoading = true;
        this.isItemHasBeenModified = false;
        this.isGlobal = true;
        this.selectedMasterClass = {};
        await this.getGlobalRates();
        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    async manageRate(masterClass) {
      try {
        this.isLoading = true;
        this.isItemHasBeenModified = false;
        this.isGlobal = false;
        this.selectedMasterClass = masterClass;

        await this.getRates(masterClass.masterClassId);

        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await sellingTariffAncillaryRateService.delete(this.itemIdToBeDeleted);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        if (this.isGlobal) {
          await this.getGlobalRates();
        } else {
          await this.getRates(this.selectedMasterClass.masterClassId);
        }
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          $("body").addClass("modal-open");
        }, 500);
      }
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    async onCloseModal() {
      this.onResetForm();

      $(this.$refs.vuemodal).modal("hide");

      if (this.isItemHasBeenModified) {
        await this.getAll();
      }
    },
    async addPredefinedName() {
      const predefinedName = prompt("Please enter new model name:", "");
      if (predefinedName && predefinedName !== "") {
        try {
          await masterAncillaryService.create({ name: predefinedName });
          await this.getPredefinedNames();
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        } catch (error) {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      }
    },
    async onChangeStatus(item) {
      try {
        this.isLoading = true;
        this.bindModel(item);
        this.model.isActive = !!this.model.isActive;

        try {
          this.constructPayload();
          await this.submitUpdate();
          this.isItemHasBeenModified = true;
        } catch (error) {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        } finally {
          this.isLoading = false;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    constructPayload() {
      if (this.isGlobal) {
        this.model.isGlobal = true;
        this.model.masterClassId = null;
      } else {
        this.model.isGlobal = false;
        this.model.masterClassId = this.selectedMasterClass.masterClassId;
      }

      if (this.model.serviceType == 1) {
        this.model.calculationType = AncillaryCalculationType.OneTimeCalculate;
      }

      this.model.rate = tryParseFloat(this.model.rate);
      this.model.zones = this.model.zones.map((zone) => zone.id);
    },
    async onSubmitForm() {
      this.isSubmitted = true;
      this.$v.model.$touch();

      if (this.$v.model.$error) {
        return;
      }

      try {
        this.isLoading = true;

        this.constructPayload();

        if (this.isUpdate) {
          await this.submitUpdate();
        } else {
          await this.submitCreate();
        }

        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submitCreate() {
      await sellingTariffAncillaryRateService.create(this.model);

      this.onResetForm();

      if (this.isGlobal) {
        this.getGlobalRates().then(() => {
          this.$notification.success("Successfully created.", {
            title: "Success",
          });
        });
      } else {
        this.getRates(this.selectedMasterClass.masterClassId).then(() => {
          this.$notification.success("Successfully created.", {
            title: "Success",
          });
        });
      }
    },
    async submitUpdate() {
      await sellingTariffAncillaryRateService.update(this.model);
      this.onResetForm();

      if (this.isGlobal) {
        this.getGlobalRates().then(() => {
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        });
      } else {
        this.getRates(this.selectedMasterClass.masterClassId).then(() => {
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        });
      }
    },
    openModal() {
      this.onResetForm();
      $(this.$refs.vuemodal).modal({ backdrop: "static", keyboard: false });
    },
    onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.model = Object.assign({}, defaultModel);
      this.resetValidations();
    },
    onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    bindModel(item) {
      this.model.id = item.id;
      this.model.serviceType = item.serviceType;
      this.model.masterClassId = item.masterClassId;
      this.model.name = item.name;
      this.model.currency = item.currency;
      this.model.rate = item.rate;
      this.model.calculationType =
        item.calculationType == 0 ? null : item.calculationType;
      this.model.isActive = item.isActive;
      this.model.zones = this.zones.filter((array) =>
        item.zones.some((filter) => filter.id === array.id)
      );
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    printMoney(value) {
      return this.formatter
        ? this.formatter
            .format(value)
            .replace(/[a-z]{3}/i, "")
            .trim()
        : value;
    },
    printServiceType(item) {
      if (item.serviceType == 1) {
        return "Transfer";
      } else if (item.serviceType == 2) {
        return "Hourly";
      } else {
        return "-";
      }
    },
  },
};
</script>

<style>
.modal-footer .btn + .btn {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/AncillaryRate.vue